import { Breadcrumbs } from '@/components/ui/daisy';
import useCourseTreeNavigate from '@/data/hook/course-line/useCourseTreeNavigate';
import { BreadcrumbItem } from '@/data/hook/useDynamicBreadcrumbItems';

type QuestionsModalBreadcrumbProps = {
  items: BreadcrumbItem[];
  onClose: () => void;
};

export default function QuestionsModalBreadcrumb({
  items,
  onClose,
}: QuestionsModalBreadcrumbProps) {
  const { navigate } = useCourseTreeNavigate();

  const handleClick = (item: BreadcrumbItem) => {
    if (!item.href) return;
    onClose();
    navigate(item.href, { treeKey: item.treeKey });
  };

  return (
    <Breadcrumbs>
      {items.map(item => (
        <Breadcrumbs.Item
          key={item.id}
          icon={item.icon}
          onClick={item.href ? () => handleClick(item) : undefined}
        >
          {item.children}
        </Breadcrumbs.Item>
      ))}
    </Breadcrumbs>
  );
}
